module.exports = __webpack_public_path__ + "static/media/Hengist-Of-Woodcroft.ef7180e5.jpg";